// extracted by mini-css-extract-plugin
module.exports = {"block":"Simple_block___ZsHj"};